export enum Questionnaires {
  AddClient = "http://quiltedhealth.com/q/add-client",
  AddPracticeUser = "http://quiltedhealth.com/q/add-practice-user",
  ClientIntake = "http://quiltedhealth.com/q/client-intake",
  Encounter = "http://quiltedhealth.com/q/new-encounter",
  Prenatal = "http://quiltedhealth.com/q/prenatal-encounter",
  PostpartumEncounter = "http://quiltedhealth.com/q/postpartum-encounter",
  GynecologicalEncounter = "http://quiltedhealth.com/q/gynecological-encounter",
  GynecologicalEncounterVitalsSign = "http://quiltedhealth.com/q/gynecological-encounter-vitals-sign",
  Newborn = "http://quiltedhealth.com/q/newborn-encounter",
  PrimaryCare = "http://quiltedhealth.com/q/primary-care-encounter",
  LaborAndDelivery = "http://quiltedhealth.com/q/labor-and-delivery-encounter",
  EarlyCare = "http://quiltedhealth.com/q/early-care-encounter",
  GTPAL = "http://quiltedhealth.com/q/gtpal",
  EDD = "http://quiltedhealth.com/q/edd",
  BloodType = "http://quiltedhealth.com/q/blood-type",
  LabBlood = "http://quiltedhealth.com/q/lab-blood",
  LabAntibodyScreen = "http://quiltedhealth.com/q/lab-antibody-screen",
  LabCbc = "http://quiltedhealth.com/q/lab-cbc",
  LabDiabetesScreen = "http://quiltedhealth.com/q/lab-diabetes-screen",
  LabGtt = "http://quiltedhealth.com/q/lab-gtt",
  LabPap = "http://quiltedhealth.com/q/lab-pap",
  LabHpv = "http://quiltedhealth.com/q/lab-hpv",
  LabRubella = "http://quiltedhealth.com/q/lab-rubella",
  LabGonorrhea = "http://quiltedhealth.com/q/lab-gonorrhea",
  LabHbsag = "http://quiltedhealth.com/q/lab-hbsag",
  LabChlamydia = "http://quiltedhealth.com/q/lab-chlamydia",
  LabTpaRprVdrl = "http://quiltedhealth.com/q/lab-tpa-rpr-vdrl",
  LabGbs = "http://quiltedhealth.com/q/lab-gbs",
  LabHiv = "http://quiltedhealth.com/q/lab-hiv",
  LabTsh = "http://quiltedhealth.com/q/lab-tsh",
  LabTshReflexT4f = "http://quiltedhealth.com/q/lab-tsh-reflex-t4f",
  LabTshPlusFreeT4 = "http://quiltedhealth.com/q/lab-tsh-plus-free-t4",
  LabHemoglobinA1c = "http://quiltedhealth.com/q/lab-hemoglobin-a1c",
  LabVitaminD = "http://quiltedhealth.com/q/lab-vitamin-d",
  LabNipt = "http://quiltedhealth.com/q/lab-nipt",
  LabFirstTrimesterScreen = "http://quiltedhealth.com/q/lab-first-trimester-screen",
  LabCarrierScreen = "http://quiltedhealth.com/q/lab-carrier-screen",
  Lab1HourGct = "http://quiltedhealth.com/q/lab-1-hour-gct",
  LabFastingGlucose = "http://quiltedhealth.com/q/lab-fasting-glucose",
  LabAfp = "http://quiltedhealth.com/q/lab-afp",
  LabSma = "http://quiltedhealth.com/q/lab-sma",
  LabQuadScreen = "http://quiltedhealth.com/q/lab-quad-screen",
  LabCysticFibrosis = "http://quiltedhealth.com/q/lab-cystic-fibrosis",
  LabHcg = "http://quiltedhealth.com/q/lab-hcg",
  LabInsulin = "http://quiltedhealth.com/q/lab-insulin",
  LabProgesterone = "http://quiltedhealth.com/q/lab-progesterone",
  LabTotalTestosterone = "http://quiltedhealth.com/q/lab-total-testosterone",
  LabEstradiol = "http://quiltedhealth.com/q/lab-estradiol",
  LabFsh = "http://quiltedhealth.com/q/lab-fsh",
  LabLh = "http://quiltedhealth.com/q/lab-lh",
  LabThyroid = "http://quiltedhealth.com/q/lab-thyroid",
  LabUrineCultureSensitivity = "http://quiltedhealth.com/q/lab-urine-culture-sensitivity",
  LabBacterialVaginosisSwab = "http://quiltedhealth.com/q/lab-bacterial-vaginosis-swab",
  LabVaginitisSwab = "http://quiltedhealth.com/q/lab-Vaginitis-swab",
  LabTrichomonasSwabOrUrine = "http://quiltedhealth.com/q/lab-trichomonas-swab-or-urine",
  LabCandidaSwab = "http://quiltedhealth.com/q/lab-candida-swab",
  LabHepatitisC = "http://quiltedhealth.com/q/lab-hepatitis-c",
  LabVaricellaIgg = "http://quiltedhealth.com/q/lab-varicella-igg",
  Lab3HourGtt = "http://quiltedhealth.com/q/lab-3-hour-gtt",
  Lab2HourGtt = "http://quiltedhealth.com/q/lab-2-hour-gtt",
  LabAmh = "http://quiltedhealth.com/q/lab-amh",
  LabProlactin = "http://quiltedhealth.com/q/lab-prolactin",
  LabDhea = "http://quiltedhealth.com/q/lab-dhea",
  LabFreeTestosterone = "http://quiltedhealth.com/q/lab-free-testosterone",
  LabVulvarBiopsy = "http://quiltedhealth.com/q/lab-vulvar-biopsy",
  LabEndometrialBiopsy = "http://quiltedhealth.com/q/lab-endometrial-biopsy",
  LabLipidPanel = "http://quiltedhealth.com/q/lab-lipid-panel",
  LabCmp = "http://quiltedhealth.com/q/lab-cmp",
  LabVitaminB12 = "http://quiltedhealth.com/q/lab-vitamin-b12",
  LabBileAcids = "http://quiltedhealth.com/q/lab-bile-acids",
  LabTotalIronBindingCapacity = "http://quiltedhealth.com/q/lab-total-iron-binding-capacity",
  LabIron = "http://quiltedhealth.com/q/lab-iron",
  LabFerritin = "http://quiltedhealth.com/q/lab-ferritin",
  LabFibrinogen = "http://quiltedhealth.com/q/lab-fibrinogen",
  LabLdh = "http://quiltedhealth.com/q/lab-ldh",
  LabUricAcid = "http://quiltedhealth.com/q/lab-uric-acid",
  LabAst = "http://quiltedhealth.com/q/lab-ast",
  LabAlt = "http://quiltedhealth.com/q/lab-alt",
  LabUrinalysis = "http://quiltedhealth.com/q/lab-urinalysis",
  LabRh = "http://quiltedhealth.com/q/lab-rh",
  LabAna = "http://quiltedhealth.com/q/lab-ana",
  LabEsr = "http://quiltedhealth.com/q/lab-esr",
  LabCrp = "http://quiltedhealth.com/q/lab-crp",
  LabCortisol = "http://quiltedhealth.com/q/lab-cortisol",
  LabUrineCulture = "http://quiltedhealth.com/q/lab-urine-culture",
  LabColposcopy = "http://quiltedhealth.com/q/lab-colposcopy",
  LabPCRatio = "http://quiltedhealth.com/q/lab-p-c-ratio",
  Lab24HourUrineProtein = "http://quiltedhealth.com/q/lab-24-hour-urine-protein",
  NewbornIPPBirthDetails = "http://quiltedhealth.com/q/newborn-ipp-birth-details",
  NewbornIPPSize = "http://quiltedhealth.com/q/newborn-ipp-size",
  NewbornIPPVitalsSign = "http://quiltedhealth.com/q/newborn-ipp-vitals-sign",
  DeletePhysicalExam = "http://quiltedhealth.com/q/delete-physical-exam",
  HEENTPhysicalExam = "http://quiltedhealth.com/q/heent-physical-exam",
  GeneralAppearancePhysicalExam = "http://quiltedhealth.com/q/general-appearance-physical-exam",
  BreastPhysicalExam = "http://quiltedhealth.com/q/breast-physical-exam",
  ExtremitiesPhysicalExam = "http://quiltedhealth.com/q/extremities-physical-exam",
  NeurologicPhysicalExam = "http://quiltedhealth.com/q/neurologic-physical-exam",
  HeartPhysicalExam = "http://quiltedhealth.com/q/heart-physical-exam",
  LungsPhysicalExam = "http://quiltedhealth.com/q/lungs-physical-exam",
  GenitourinaryPhysicalExam = "http://quiltedhealth.com/q/genitourinary-physical-exam",
  AbdomenPhysicalExam = "http://quiltedhealth.com/q/abdomen-physical-exam",
  BackPhysicalExam = "http://quiltedhealth.com/q/back-physical-exam",
  SkinPhysicalExam = "http://quiltedhealth.com/q/skin-physical-exam",
  PsychiatricPhysicalExam = "http://quiltedhealth.com/q/psychiatric-physical-exam",
  NewbornIPPFeeding = "http://quiltedhealth.com/q/newborn-ipp-feeding",
  NewbornIPPMedicationAndTherapies = "http://quiltedhealth.com/q/newborn-ipp-medication-and-therapies",
  NewbornIPPGestationalAge = "http://quiltedhealth.com/q/newborn-ipp-gestational-age",
  NewbornIPPEncounter = "http://quiltedhealth.com/q/newborn-ipp-encounter",
  NewbornPostpartumMedicationAndTherapies = "http://quiltedhealth.com/q/newborn-postpartum-medication-and-therapies",
  NewbornPostpartumEncounter = "http://quiltedhealth.com/q/newborn-postpartum-encounter",
  NewbornPostpartumSize = "http://quiltedhealth.com/q/newborn-postpartum-size",
  NewbornPostpartumStateOfNewborn = "http://quiltedhealth.com/q/newborn-postpartum-state-of-newborn",
  NewbornPostpartumVitalsSign = "http://quiltedhealth.com/q/newborn-postpartum-vitals-sign",
  NewbornPostpartumInputOutput = "http://quiltedhealth.com/q/newborn-postpartum-input-output",
  GynecologicalPhysicalExamsPerineumAndExternalGenitalia = "http://quiltedhealth.com/q/gynecological-perineum-and-external-genitalia-physical-exam",
  GynecologicalPhysicalExamsNeck = "http://quiltedhealth.com/q/gynecological-neck-physical-exam",
  GynecologicalPhysicalExamsAbdomen = "http://quiltedhealth.com/q/gynecological-abdomen-physical-exam",
  PostpartumFeeding = "http://quiltedhealth.com/q/postpartum-feeding",
  PostpartumLochia = "http://quiltedhealth.com/q/postpartum-lochia",
  PostpartumOutputs = "http://quiltedhealth.com/q/postpartum-outputs",
  PostpartumMedicationAndTherapies = "http://quiltedhealth.com/q/postpartum-medication-and-therapies",
  PostpartumActivityNutrition = "http://quiltedhealth.com/q/postpartum-activities-nutrition",
  PostpartumSleep = "http://quiltedhealth.com/q/postpartum-sleep",
  PostpartumSocialHealth = "http://quiltedhealth.com/q/postpartum-social-health",
  PostpartumEmotionalHealth = "http://quiltedhealth.com/q/postpartum-emotional-health",
  PostpartumSexualActivity = "http://quiltedhealth.com/q/postpartum-sexual-activity",
  PostpartumVitals = "http://quiltedhealth.com/q/postpartum-vitals",
  NewbornSystemsAppearance = "http://quiltedhealth.com/q/newborn-systems-appearance",
  NewbornSystemsTone = "http://quiltedhealth.com/q/newborn-systems-tone",
  NewbornSystemsSkinAndBirthmarks = "http://quiltedhealth.com/q/newborn-systems-skin-and-birthmarks",
  NewbornSystemsHeadAndNeck = "http://quiltedhealth.com/q/newborn-systems-head-and-neck",
  NewbornSystemsEyes = "http://quiltedhealth.com/q/newborn-systems-eyes",
  NewbornSystemsMouthAndPalate = "http://quiltedhealth.com/q/newborn-systems-mouth-and-palate",
  NewbornSystemsEars = "http://quiltedhealth.com/q/newborn-systems-ears",
  NewbornSystemsAbdomen = "http://quiltedhealth.com/q/newborn-systems-abdomen",
  NewbornSystemsHeartSounds = "http://quiltedhealth.com/q/newborn-systems-heart-sounds",
  NewbornSystemsPulses = "http://quiltedhealth.com/q/newborn-systems-pulses",
  NewbornSystemsLungs = "http://quiltedhealth.com/q/newborn-systems-lungs",
  NewbornSystemsUmbilicus = "http://quiltedhealth.com/q/newborn-systems-umbilicus",
  NewbornSystemsGenitourinary = "http://quiltedhealth.com/q/newborn-systems-genitourinary",
  NewbornSystemsAnus = "http://quiltedhealth.com/q/newborn-systems-anus",
  NewbornSystemsHips = "http://quiltedhealth.com/q/newborn-systems-hips",
  NewbornSystemsSpine = "http://quiltedhealth.com/q/newborn-systems-spine",
  NewbornSystemsMusculoskeletal = "http://quiltedhealth.com/q/newborn-systems-musculoskeletal",
  NewbornSystemsReflexes = "http://quiltedhealth.com/q/newborn-systems-reflexes",
  MusculoskeletalPhysicalExam = "http://quiltedhealth.com/q/musculoskeletal-physical-exam",
  TransferOfCare = "http://quiltedhealth.com/q/transfer-of-care",
  TransferOfCareClientInformation = "http://quiltedhealth.com/q/transfer-of-care-client-information",
  AddCareTeam = "http://quiltedhealth.com/q/add-care-team",
  UpdateCareTeam = "http://quiltedhealth.com/q/update-care-team",
  TransferOfCareTransferProvider = "http://quiltedhealth.com/q/transfer-of-care-transfer-provider",
  TransferOfCareReceivingProvider = "http://quiltedhealth.com/q/transfer-of-care-receiving-provider",
  TransferOfCareTransferDetails = "http://quiltedhealth.com/q/transfer-of-care-transfer-details",
  CPTCodes = "http://quiltedhealth.com/q/cpt-codes",
  SendWelcomeEmail = "http://quiltedhealth.com/q/send-welcome-email",
  PregnancyCloseout = "http://quiltedhealth.com/q/pregnancy-closeout",
  InsuranceBenefitsVerification = "http://quiltedhealth.com/q/insurance-benefits-verification",
  EncounterProcedures = "http://quiltedhealth.com/q/encounter-procedures",
  StatementSettings = "http://quiltedhealth.com/q/statement-settings",
}

export enum PhysicalExamQuestionnaires {
  HEENTPhysicalExam = "http://quiltedhealth.com/q/heent-physical-exam",
  GeneralAppearancePhysicalExam = "http://quiltedhealth.com/q/general-appearance-physical-exam",
  BreastPhysicalExam = "http://quiltedhealth.com/q/breast-physical-exam",
  ExtremitiesPhysicalExam = "http://quiltedhealth.com/q/extremities-physical-exam",
  NeurologicPhysicalExam = "http://quiltedhealth.com/q/neurologic-physical-exam",
  HeartPhysicalExam = "http://quiltedhealth.com/q/heart-physical-exam",
  LungsPhysicalExam = "http://quiltedhealth.com/q/lungs-physical-exam",
  GenitourinaryPhysicalExam = "http://quiltedhealth.com/q/genitourinary-physical-exam",
  AbdomenPhysicalExam = "http://quiltedhealth.com/q/abdomen-physical-exam",
  BackPhysicalExam = "http://quiltedhealth.com/q/back-physical-exam",
  SkinPhysicalExam = "http://quiltedhealth.com/q/skin-physical-exam",
  PsychiatricPhysicalExam = "http://quiltedhealth.com/q/psychiatric-physical-exam",
  MusculoskeletalPhysicalExam = "http://quiltedhealth.com/q/musculoskeletal-physical-exam",
}

export enum NewbornSystemsQuestionnaires {
  Appearance = "http://quiltedhealth.com/q/newborn-systems-appearance",
  Tone = "http://quiltedhealth.com/q/newborn-systems-tone",
  SkinAndBirthmarks = "http://quiltedhealth.com/q/newborn-systems-skin-and-birthmarks",
  HeadAndNeck = "http://quiltedhealth.com/q/newborn-systems-head-and-neck",
  Eyes = "http://quiltedhealth.com/q/newborn-systems-eyes",
  MouthAndPalate = "http://quiltedhealth.com/q/newborn-systems-mouth-and-palate",
  Ears = "http://quiltedhealth.com/q/newborn-systems-ears",
  Abdomen = "http://quiltedhealth.com/q/newborn-systems-abdomen",
  HeartSounds = "http://quiltedhealth.com/q/newborn-systems-heart-sounds",
  Pulses = "http://quiltedhealth.com/q/newborn-systems-pulses",
  Lungs = "http://quiltedhealth.com/q/newborn-systems-lungs",
  Umbilicus = "http://quiltedhealth.com/q/newborn-systems-umbilicus",
  Genitourinary = "http://quiltedhealth.com/q/newborn-systems-genitourinary",
  Anus = "http://quiltedhealth.com/q/newborn-systems-anus",
  Hips = "http://quiltedhealth.com/q/newborn-systems-hips",
  Spine = "http://quiltedhealth.com/q/newborn-systems-spine",
  Musculoskeletal = "http://quiltedhealth.com/q/newborn-systems-musculoskeletal",
  Reflexes = "http://quiltedhealth.com/q/newborn-systems-reflexes",
}

export enum PostpartumPhysicalExamsQuestionnaires {
  PerineumAndExternalGenitaliaPhysicalExam = "http://quiltedhealth.com/q/perineum-and-external-genitalia-postpartum-physical-exam",
  NeckPhysicalExam = "http://quiltedhealth.com/q/neck-postpartum-physical-exam",
  AbdomenPhysicalExam = "http://quiltedhealth.com/q/abdomen-postpartum-physical-exam",
}

export enum GynecologicalPhysicalExamsQuestionnaires {
  AbdomenPhysicalExam = "http://quiltedhealth.com/q/gynecological-abdomen-physical-exam",
  PerineumAndExternalGenitaliaPhysicalExam = "http://quiltedhealth.com/q/gynecological-perineum-and-external-genitalia-physical-exam",
  NeckPhysicalExam = "http://quiltedhealth.com/q/gynecological-neck-physical-exam",
}

export enum NewbornPostpartumPhysicalExamsQuestionnaires {
  Head = "http://quiltedhealth.com/q/head-newborn-postpartum-physical-exam",
  Eyes = "http://quiltedhealth.com/q/eyes-newborn-postpartum-physical-exam",
  Ears = "http://quiltedhealth.com/q/ears-newborn-postpartum-physical-exam",
  NoseAndMouth = "http://quiltedhealth.com/q/nose-and-mouth-newborn-postpartum-physical-exam",
  Neck = "http://quiltedhealth.com/q/neck-newborn-postpartum-physical-exam",
  ChestAndAbdomen = "http://quiltedhealth.com/q/chest-and-abdomen-newborn-postpartum-physical-exam",
  HipsAndExtremities = "http://quiltedhealth.com/q/hips-and-extremities-newborn-postpartum-physical-exam",
  BackAndSpine = "http://quiltedhealth.com/q/back-and-spine-newborn-postpartum-physical-exam",
}

export enum NewbornProceduresQuestionnaires {
  HearingScreeningTest = "http://quiltedhealth.com/q/hearing-screening-test-newborn-procedures",
  MetabolicScreen = "http://quiltedhealth.com/q/metabolic-screen-newborn-procedures",
  PulseOximetry = "http://quiltedhealth.com/q/pulse-oximetry-newborn-procedures",
  UmbilicalCauterization = "http://quiltedhealth.com/q/umbilical-cauterization-newborn-procedures",
  Frenulectomy = "http://quiltedhealth.com/q/frenulectomy-newborn-procedures",
  TranscutaneousBilirubinTesting = "http://quiltedhealth.com/q/transcutaneous-bilirubin-testing-newborn-procedures",
  TotalSerumBilirubinTesting = "http://quiltedhealth.com/q/total-serum-bilirubin-testing-newborn-procedures",
}

export enum NewbornProceduresParentQuestionnaire {
  Base = "http://quiltedhealth.com/fhir/Questionnaire/newborn-procedures",
}

export enum AssessmentQuestionnaires {
  Aces = "http://loinc.org/q/82813-7",
  AuditC = "http://loinc.org/q/72109-2",
  CageAid = "http://quiltedhealth.com/q/cage-aid-assessment",
  Crafft = "http://quiltedhealth.com/q/crafft-assessment",
  Epds = "http://loinc.org/q/71354-5",
  Gad7 = "http://loinc.org/q/69737-5",
  HoosJr = "http://loinc.org/q/82316-1",
  KoosJr = "http://loinc.org/q/82324-5",
  Mdq = "http://quiltedhealth.com/q/mdq-assessment",
  Ndi = "http://loinc.org/q/82226-2",
  Odi = "http://quiltedhealth.com/q/odi-assessment",
  Ort = "http://quiltedhealth.com/q/ort-assessment",
  Pass = "http://quiltedhealth.com/q/pass-assessment",
  Peg = "http://loinc.org/q/91148-7",
  Phq2 = "http://loinc.org/q/55757-9",
  Phq9 = "http://loinc.org/q/44249-1",
  Prepare = "https://loinc.org/93025-5/",
  Steadi = "http://quiltedhealth.com/q/steadi-assessment",
}
